export enum WalletType {
  METAMASK = "METAMASK",
  WALLET_CONNECT = "WALLET_CONNECT",
  COINBASE = "COINBASE",
}
